import ReactDOM from 'react-dom/client'
import { StrictMode } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { ThemeProvider } from 'styled-components'
import { GlobalStyles, GlobalFonts } from '@diversioteam/diversio-ds'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { BrowserRouter } from 'react-router-dom'

// 🚨 CRITICAL: Initialize backend request blocker FIRST - before ANY other imports
import { initializeRequestBlocker } from '@/utils/blockBackendRequests'
initializeRequestBlocker()

// CRITICAL: Font imports MUST be before globals.css
import './assets/fonts.css'
import './styles/globals.css'
import App from './App'

import { queryClient } from '@/lib/react-query'
import { initSentry } from '@/lib/sentry'
import { store, persistor } from '@/store/store'
import { initializeNotificationAudio } from '@/utils/notificationSound'

// Simple theme object for styled-components
const theme = {}

// Initialize Sentry before mounting the app
initSentry()

// Initialize notification audio
initializeNotificationAudio()

// Initialize the app
ReactDOM.createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <BrowserRouter>
            <Provider store={store}>
                <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
                    <QueryClientProvider client={queryClient}>
                        <ThemeProvider theme={theme}>
                            <GlobalFonts />
                            <GlobalStyles />
                            <App />
                            {import.meta.env.DEV && (
                                <ReactQueryDevtools
                                    initialIsOpen={false}
                                    position="bottom"
                                    buttonPosition="bottom-right"
                                />
                            )}
                        </ThemeProvider>
                    </QueryClientProvider>
                </PersistGate>
            </Provider>
        </BrowserRouter>
    </StrictMode>,
)
